module.exports = __webpack_public_path__ + "img/hindi-lang.56421e72.svg";